export enum GameState {
    Started,
    Pause,
    End
}